import script from "./CartConfigCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CartConfigCard.vue?vue&type=script&setup=true&lang=js"

export default script